import { render } from "./ManagerUserRolesView.vue?vue&type=template&id=77009315"
import script from "./ManagerUserRolesView.vue?vue&type=script&lang=js"
export * from "./ManagerUserRolesView.vue?vue&type=script&lang=js"

import "./ManagerUserRolesView.vue?vue&type=style&index=0&id=77009315&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__